<template>
  <div>
    <span v-if="nextStatus.length === 0" class="source-status edit-status">
      <a-tag v-if="requirementStatus[status]" :color="requirementStatus[status].color"> {{ requirementStatus[status].label }}</a-tag>
      <a-tag v-else>{{ status }}</a-tag>
    </span>
    <span v-else>
      <a-dropdown :trigger="['click']">
        <span class="source-status edit-status">
          <a-tag v-if="requirementStatus[status]" :color="requirementStatus[status].color">{{ requirementStatus[status].label }}</a-tag>
          <a-tag v-else>{{ status }}</a-tag>
          <a-icon class="icon-down" type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item v-for="(item, index) in nextStatus" :key="index" @click="onChange(item.node_id)">
            <a-tag v-if="requirementStatus[item.node_id]" :color="requirementStatus[item.node_id].color">{{ requirementStatus[item.node_id].label }}</a-tag>
            <a-tag v-else>{{ item.node_id }}</a-tag>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </span>
  </div>
</template>
<script>
import { requirementStatus } from '@/utils/dictionary';
import { updateStatusBusinessRequirement } from '@/api/business/requirement';

export default {
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    status: {
      type: [String, Number],
      default: null
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      requirementStatus
    };
  },
  methods: {
    onChange(value) {
      updateStatusBusinessRequirement({ id: this.sourceId, status: value }).then(() => {
        this.$emit('ok');
        this.$message.success('状态更新成功');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.source-status {
  cursor: pointer;
  display: inline-block;
  padding: 2px;
  padding-right: 2px;
  line-height: 22px;
  border-radius: 4px;
  .ant-tag {
    margin-right: 2px;
  }
  .icon-down {
    opacity: 0;
  }
}

.edit-status:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
</style>
